import { Link } from "react-router-dom";
import { Heart, ShoppingBag } from "lucide-react";
import { inr } from "@/lib/api";
import { useShop } from "@/context/ShopContext";

export default function ProductCard({ product }) {
  const { addToCart, toggleWishlist, inWishlist } = useShop();
  const discount = product.mrp && product.mrp > product.price
    ? Math.round((1 - product.price / product.mrp) * 100) : 0;
  const wished = inWishlist(product.id);
  const isCustom = product.customizable || product.product_type === "vendor";

  return (
    <div
      data-testid={`product-card-${product.slug}`}
      className="group relative flex flex-col rounded-2xl border border-border bg-card overflow-hidden transition-transform transition-shadow duration-300 ease-out hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(10,15,22,0.10)]"
    >
      <button
        data-testid={`wishlist-toggle-${product.slug}`}
        onClick={(e) => { e.preventDefault(); toggleWishlist(product); }}
        className="absolute right-3 top-3 z-10 grid h-9 w-9 place-items-center rounded-full bg-white/90 backdrop-blur border border-border text-midnight transition-colors hover:bg-white"
        aria-label="Toggle wishlist"
      >
        <Heart className={`h-4 w-4 ${wished ? "fill-red-500 text-red-500" : ""}`} />
      </button>
      {discount > 0 && (
        <span className="absolute left-3 top-3 z-10 rounded-full bg-gold px-2.5 py-1 text-[11px] font-bold text-midnight">
          {discount}% OFF
        </span>
      )}
      <Link to={`/product/${product.slug}`} className="block overflow-hidden bg-secondary">
        <div className="aspect-square w-full overflow-hidden">
          <img
            src={product.images?.[0]}
            alt={product.name}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 ease-out group-hover:scale-105"
          />
        </div>
      </Link>
      <div className="flex flex-1 flex-col p-4">
        <span className="text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">{product.brand}</span>
        <Link to={`/product/${product.slug}`} className="mt-1 line-clamp-2 text-sm font-semibold text-midnight hover:text-gold-dark">
          {product.name}
        </Link>
        <div className="mt-auto pt-3 flex items-end justify-between gap-2">
          <div className="flex flex-col">
            <span className="text-base font-extrabold text-midnight">{inr(product.price)}</span>
            {product.mrp && product.mrp > product.price && (
              <span className="text-xs text-muted-foreground line-through">{inr(product.mrp)}</span>
            )}
          </div>
          {isCustom ? (
            <Link
              to={`/product/${product.slug}`}
              data-testid={`customize-${product.slug}`}
              className="rounded-full bg-mart-wood px-3 py-2 text-xs font-semibold text-white transition-colors hover:opacity-90"
            >
              Customize
            </Link>
          ) : (
            <button
              data-testid={`add-to-cart-${product.slug}`}
              onClick={() => addToCart(product.id)}
              className="grid h-10 w-10 place-items-center rounded-full bg-midnight text-white transition-transform duration-200 hover:scale-105 active:scale-95"
              aria-label="Add to cart"
            >
              <ShoppingBag className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
